<template>
    <div style="display: flex; flex-direction: column; position: relative;">
        <ModalHeader title="설정" :is-show-back-btn="false" :is_left_area_custom="false" ></ModalHeader>
        <div style="flex:1;  overflow:auto; padding:30px 20px;">
            <div style="font-size:24px; font-weight:bold;">알림 설정</div>

            <div style="display: flex; margin-top: 40px; align-items: center; gap: 20px;">
                <div style="font-weight: 500; font-size:18px;">근무자 모집 알림</div>
                <div style="flex:1;"></div>
                <CommonSwitch :completeAction="setAlarm" :init-state="init_state"></CommonSwitch>
            </div>

            <div style="position:relative; padding:10px 0px; margin-top:20px;">
                <div style="display: flex; align-items: center; gap: 20px; ">
                    <div style="font-weight: 500; font-size:18px;">근로 예약 알림</div>
                    <div style="flex:1;"></div>
                    <CommonSwitch :completeAction="() => {}" :init-state="state_push"></CommonSwitch>
                </div>
                <div style="margin-top:10px; font-size:16px;">(근로 확정 및 취소에 대한 알림을 받습니다.)</div>
                <div style="position:absolute; left:0px; top:0px; width:100%; height:100%;background-color: #8f8f8f;mix-blend-mode: screen; z-index:10" @click.stop.prevent="() => {}"></div>
            </div>

            <div style="margin-top:20px; font-size:16px;">확정, 취소 알림이 오지 않는다면<br>휴대폰의 알림 설정을 확인해주세요.</div>

            <div style="width: 100%;padding: 12px;background-color: var(--color-main); color: white;font-size: 16px; margin-top: 40px; position: relative; min-height: 44px;display: flex;lign-items: center;justify-content: center;border-radius: 12px;cursor: pointer;" @click="goAppSetting">알림 설정으로 이동</div>

        </div>
        <PageBottom />
    </div>
</template>

<script>
import PageBottom from "@/components/common/PageBottom";
import ModalHeader from "@/components/common/ModalHeader";
import CommonSwitch from "@/components/common/CommonSwitch";

export default {
    name: "Setting",
    components: {ModalHeader, PageBottom, CommonSwitch},
    data(){
        return {
            init_state : 1,
            state_push : 1
        }
    },
    methods : {
        async setAlarm(state) {
            // localStorage.setItem('ALARM_NOTICE_ALLOW', state)
            const parameters = {};
            parameters.is_recruit_push_allow = state
            const res = await this.$Axios.post('/api/member/push/save', parameters)
            this.$GlobalStore.setLoginInfo(res.data.loginInfo);
        },
        async getDefaultData() {
            const res = await this.$Axios.get('/api/default');
            if(res.data.loginInfo) {
                this.$GlobalStore.setLoginInfo(res.data.loginInfo);
                this.init_state = this.$GlobalStore.loginInfo().is_recruit_push_allow;
            }
        },
        goAppSetting(){
            const device = this.$cookies.get('device');
            if(device === 'android'){
                window.Android.showAppSetting();
            }else if(device === 'ios'){
                /*eslint-disable no-undef */
                webkit.messageHandlers.ios.postMessage({cmd : 'showAppSetting'});
            }
        }
    },
    created(){
        this.getDefaultData();

        // if(this.$hasOwnProperty(localStorage, 'ALARM_NOTICE_ALLOW')){
        //     this.init_state = parseInt(localStorage.getItem('ALARM_NOTICE_ALLOW'))
        // }
    }
}
</script>

<style scoped>
.switch_wrapper {
    width: 100px; 
    background-color: #fff; 
    border-radius: 24px; 
    box-shadow: 0 0px 8px rgba(0, 0, 0, 0.2); 
    display: flex; 
    padding: 10px 0;
    position: relative;
}
</style>